module.exports = __webpack_public_path__ + "static/media/award.dde06b51.svg";